import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'fm-col',
  templateUrl: 'form-column.component.html'
})
export class FormColumnComponent
  implements  OnInit, OnDestroy {
  constructor(
  ) {
  }
    
  colClass: string = "col-xs-4";
  labelClass: string = "col-xs-4";
  divClass: string = "col-xs-6";
  
  @Input() set cols(n: number) {
    switch (n) {
      case 3: 
        this.colClass = "col-xs-4";
        break;
      case 2:
        this.colClass = "col-xs-6";
        break;
    }
  }

  @Input() set ratio(ratio: string) {
    let arr = ratio.split(':');
    if (arr.length === 2) {
      this.labelClass = "col-xs-" + arr[0];
      this.divClass = "col-xs-" + arr[1];
    }
  }

  ngOnInit() {
  }
  
  ngOnDestroy() {
  }
}
